'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Grid = require('./Grid');

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Half = function Half(props) {
  return _react2.default.createElement(_Grid2.default, _extends({}, props, { width: [1, 1 / 2] }));
};
Half.displayName = 'Half';

exports.default = Half;


//////////////////
// WEBPACK FOOTER
// ./~/grid-styled/dist/Half.js
// module id = 541
// module chunks = 3